import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import ReactFileReader from 'react-file-reader';
import * as loadJS from "load-js";
import { urlAddUrlParam } from './utils/index';
import PropTypes from 'prop-types';
import './index.css';
var ImageAdUpload = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ImageAdUpload, _React$Component);
  function ImageAdUpload(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.canvasDataURL = _this.canvasDataURL.bind(_assertThisInitialized(_this));
    _this.mtopImageUpload = _this.mtopImageUpload.bind(_assertThisInitialized(_this));
    _this.compressAndUploadImg = _this.compressAndUploadImg.bind(_assertThisInitialized(_this));
    _this.successJump = _this.successJump.bind(_assertThisInitialized(_this));
    _this.handleFiles = _this.handleFiles.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = ImageAdUpload.prototype;
  _proto.componentDidMount = function componentDidMount() {
    // 本地测试时，添加mtopjs
    loadJS(["https://g.alicdn.com/mtb/??lib-promise/3.1.3/polyfillB.js,lib-mtop/2.4.11/mtop.js"]).then(function () {
      window.lib.mtop.config.prefix = "h5api"; // mtop的前缀
      window.lib.mtop.config.subDomain = "m"; // mtop的子域
      window.lib.mtop.config.mainDomain = "1688.com"; // mtop的主域
    });
  }

  // 转换图片为base64
  ;
  _proto.canvasDataURL =
  /*#__PURE__*/
  function () {
    var _canvasDataURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, width, height) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              var img = new Image();
              img.src = path;
              img.onload = function () {
                var that = this;
                var w = width,
                  h = height;
                var quality = 0.8; //重定图片质量为0.8
                //生成canvas
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                //创建属性节点
                var anw = document.createAttribute('width');
                anw.nodeValue = w;
                var anh = document.createAttribute('height');
                anh.nodeValue = h;
                canvas.setAttributeNode(anw);
                canvas.setAttributeNode(anh);
                ctx.drawImage(that, 0, 0, w, h);
                var newBase64 = canvas.toDataURL('image/jpeg', quality);
                resolve(newBase64); //回调函数显示base64的值
              };
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function canvasDataURL(_x, _x2, _x3) {
      return _canvasDataURL.apply(this, arguments);
    }
    return canvasDataURL;
  }() // mtop图片上传请求
  ;
  _proto.mtopImageUpload =
  /*#__PURE__*/
  function () {
    var _mtopImageUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(imageBase64) {
      var res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return window.lib.mtop.request({
              api: "mtop.1688.imageService.putImage",
              data: JSON.stringify({
                imageBase64: imageBase64,
                appName: "searchImageUpload",
                appKey: "pvvljh1grxcmaay2vgpe9nb68gg9ueg2"
              }),
              ecode: "0",
              v: "1.0",
              type: 'POST'
            });
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function mtopImageUpload(_x4) {
      return _mtopImageUpload.apply(this, arguments);
    }
    return mtopImageUpload;
  }() // 获取图片宽高
  ;
  _proto.getImg = function getImg(imgBase64) {
    return new Promise(function (resolve, reject) {
      var newImg = new Image();
      newImg.src = imgBase64;
      newImg.onload = function () {
        return resolve({
          width: newImg.width,
          height: newImg.height
        });
      };
    });
  }

  // 压缩并上传图片
  ;
  _proto.compressAndUploadImg = function compressAndUploadImg(imgBase64) {
    var self = this;
    var _self$props = self.props,
      width = _self$props.width,
      height = _self$props.height;
    var widthNum = width.match(/\d+/);
    var heightNum = height.match(/\d+/);
    return self.getImg(imgBase64).then(function (img) {
      var maxLength = 360;
      if (img.width > maxLength && img.height > maxLength) {
        //判断宽高并重定
        if (widthNum < heightNum) {
          img.height = maxLength / img.width * img.height;
          img.width = maxLength;
        } else {
          img.width = maxLength / img.height * img.width;
          img.height = maxLength;
        }
      }
      return self.canvasDataURL(imgBase64, img.width, img.height);
    }).then(function (zipBase64) {
      if (!zipBase64 || zipBase64.indexOf(',') < -1) {
        // toast.error('亲 图片解析异常 请重新上传');
        return;
      }
      var uploadData = zipBase64.split(',')[1];
      return self.mtopImageUpload(uploadData);
    });
  }

  // 上传成功之后跳转
  ;
  _proto.successJump = function successJump(imageIdList) {
    var _this$props = this.props,
      urlParam = _this$props.urlParam,
      spm = _this$props.spm,
      domId = _this$props.domId;
    // 如果props中spm为空，那么就将imgBtn的spm传递进去
    var jumpUrl = "https://s.1688.com/p4p/image/index.html?tab=imageSearch";
    jumpUrl = jumpUrl + "&imageId=" + imageIdList[0] + "&spm=" + spm + "&imageIdList=" + imageIdList.join(',');
    jumpUrl = urlAddUrlParam(jumpUrl, urlParam); // 添加参数
    window.location.href = jumpUrl;
  }

  // 点击上传
  ;
  _proto.handleFiles = function handleFiles(fileData) {
    var self = this;
    var imgLimit = 6;
    if (!fileData || !fileData.base64 || fileData.base64 === '' || fileData.base64.length === 0) {
      // toast.error('亲，这张图片无法识别，请换一张图片！');
      return;
    }
    // 两种逻辑 用户直接选了6张+
    if (fileData.base64.length > imgLimit) {
      // toast.error('亲，一次只能最多上传' + imgLimit + '张图片，请去掉多余的图片');
      return;
    }
    var imgReqArr = fileData.base64.map(function (img) {
      return self.compressAndUploadImg(img);
    });
    Promise.all(imgReqArr).then(function (res) {
      var newImageIdList = res.filter(function (item) {
        return item && item.imageId && item.imageId !== '';
      }).map(function (result) {
        return result.imageId;
      });
      self.successJump(newImageIdList);
    });
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height;
    return /*#__PURE__*/React.createElement(ReactFileReader, {
      handleFiles: this.handleFiles,
      base64: true,
      multipleFiles: true
    }, /*#__PURE__*/React.createElement("div", {
      id: "img-ad-upload",
      style: {
        width: width,
        height: height,
        backgroundImage: "url(https://img.alicdn.com/imgextra/i3/O1CN0116UWgv1ouZsMOIfA7_!!6000000005285-2-tps-60-52.png)",
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat'
      }
    }));
  };
  return ImageAdUpload;
}(React.Component);
ImageAdUpload.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired
};
ImageAdUpload.defaultProps = {
  width: '30px',
  height: '26px',
  domId: 'img-search-upload'
};
export default ImageAdUpload;